/**
 * Absolute paths for React Router from any nested route.
 * Relative `to="dashboard"` under `/home/.../scheduling-profile` resolves as a
 * child of the current URL and corrupts the path (stacked segments).
 */

const trimLeadingSlashes = (s) => String(s).replace(/^\/+/, "")

/**
 * @param {string} [relativeUnderHome] Segments under /home, e.g. "", "dashboard", "schedule-management/master-calendar"
 * @returns {string}
 */
export function toHomePath(relativeUnderHome) {
  if (relativeUnderHome == null || relativeUnderHome === "") return "/home"
  const s = trimLeadingSlashes(relativeUnderHome)
  if (s === "home") return "/home"
  if (s.startsWith("home/")) return `/${s}`.replace(/\/+/g, "/")
  return `/home/${s}`
}

/**
 * Dashboard area tabs live under /home/dashboard/*
 * @param {string} segment e.g. "candidates", "landing-page"
 */
export function toDashboardPath(segment) {
  if (segment == null || segment === "") return "/home/dashboard"
  return `/home/dashboard/${trimLeadingSlashes(segment)}`
}

/**
 * Spend management sub-routes under /home/spend-management/*
 * @param {string} [segment] e.g. "" for main, "spend-mtg-invoices"
 */
export function toSpendManagementPath(segment) {
  if (segment == null || segment === "") return "/home/spend-management"
  return `/home/spend-management/${trimLeadingSlashes(segment)}`
}
